import { render, staticRenderFns } from "./CrownIcon.vue?vue&type=template&id=5e6a7d0a"
import script from "./CrownIcon.vue?vue&type=script&lang=js"
export * from "./CrownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6a7d0a')) {
      api.createRecord('5e6a7d0a', component.options)
    } else {
      api.reload('5e6a7d0a', component.options)
    }
    module.hot.accept("./CrownIcon.vue?vue&type=template&id=5e6a7d0a", function () {
      api.rerender('5e6a7d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/svg/CrownIcon.vue"
export default component.exports